import styled from 'styled-components';

import {
  GREEN,
  MEDIUM_GRAY,
  RED,
} from 'root/theme';

const PercentText = styled.div`
  font-size: 11px;
  font-weight: bold;
  color: ${(props) => Number(props.score) > 69 ? GREEN : RED};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

const NoPercentText = styled.div`
  font-size: 11px;
  font-weight: bold;
  color: ${MEDIUM_GRAY};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 0px 5px 0px 7px;
`;

export {
  PercentText,
  NoPercentText,
};
